/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ExternalCostRowDto interface.
 */
export function instanceOfExternalCostRowDto(value) {
    return true;
}
export function ExternalCostRowDtoFromJSON(json) {
    return ExternalCostRowDtoFromJSONTyped(json, false);
}
export function ExternalCostRowDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'costTypeId': json['costTypeId'] == null ? undefined : json['costTypeId'],
    };
}
export function ExternalCostRowDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'groupId': value['groupId'],
        'projectId': value['projectId'],
        'costTypeId': value['costTypeId'],
    };
}
